module.exports = __webpack_public_path__ + "static/media/Dark-logo.6eaecd36.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/auth/login/components/login-form/Dark-logo.png
// module id = 572
// module chunks = 0